// Shop.jsx

import "./Shop.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Shop = ({ dark }) => {
  return (
    <div className={`shop-coming-page ${dark ? "dark" : "light"}`}>
      <Helmet>
        <title>FadaSports Shop - Official Merchandise & Sportswear Coming Soon</title>
        <meta name="description" content="Coming soon: Official FadaSports merchandise, fan gear, sportswear, collectibles, and exclusive products for football supporters worldwide." />
        <meta name="keywords" content="football merchandise, sports shop, fan gear, team merchandise, sporting goods, collectibles" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="FadaSports Shop" />
        <meta property="og:description" content="Official FadaSports merchandise and fan gear coming soon." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
      
      <div className="shop-coming-container">

        <div className="shop-badge">
          <span>FadaSports Shop</span>
        </div>

        <h1>
          Shop <span>Coming Soon</span>
        </h1>

        <p>
          We are building the official FadaSports Shop experience —
          bringing fans closer to football with premium merchandise,
          sportswear, collectibles, fan gear, accessories, and more.
        </p>

        <p>
          Stay tuned for exclusive drops, club collections, limited
          editions, and officially inspired football products designed
          for passionate supporters.
        </p>

        <div className="shop-coming-actions">

          <Link to="/">
            <button className="primary-btn">
              Back Home
            </button>
          </Link>

          <Link to="/contact-us">
            <button className="secondary-btn">
              Contact Us
            </button>
          </Link>

        </div>

        <div className="shop-coming-features">

          <div className="shop-feature-card">
            <h3>Official Fan Gear</h3>
            <p>
              Jerseys, scarves, football fashion, and supporter essentials.
            </p>
          </div>

          <div className="shop-feature-card">
            <h3>Fast Experience</h3>
            <p>
              A modern shopping experience optimized for all devices.
            </p>
          </div>

          <div className="shop-feature-card">
            <h3>Exclusive Drops</h3>
            <p>
              Limited football collections and special fan releases.
            </p>
          </div>

        </div>

      </div>

    </div>
  );
};

export default Shop;